import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";
import AvatarEditor from "../../Components/Forms/AvatarEditor";
import SubmittingDialog from "../../Components/Loading/SubmittingDialog";

// Libraries
import Form from "react-bootstrap/Form";




export default function EditUser() {
    const params = useParams();
    const { user } = useAuthContext();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [formErrors, setFormErrors] = useState({ firstName: "" });
    const [loading, setLoading] = useState(true);
    const [resetPassword, setResetPassword] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    


    const [form, setForm] = useState({
        role: "User"
    });

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value,
        });
    };

    // Load user
    useEffect(() => {
        console.log("loading user...", params.id);

        if (user.id != params.id && user.role != "Admin")
            setError("You don't have permission to edit this user");

        axios
            .get(`https://${process.env.REACT_APP_IP}/api/users/${params.id}`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Users:", res.data);
                setForm(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log("ERROR:", err);
                setLoading(false);
                if (err.response.status == "404")
                    setError(err.response.data);
                if (err.response.status == "403")
                    setError("You don't have permission to edit this user");
                else
                    setError(err.response.data);
            });

    }, [])

    useEffect(() => {

        if (isValid) {
            setSubmitting(true);
            axios
                .put(`https://${process.env.REACT_APP_IP}/api/users/${form.id}`,
                    form,
                    { headers: { Authorization: `bearer ${user.token}` } }
                )
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);
                    if (res.status === 200) {
                        navigate(`/Users/View/${res.data.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);

                    setFormErrors(err.response.data.errors);
                    if (err.response.status == "404")
                        setError(err.response.data);
                    if (err.response.status == "403")
                        setError("You dont have permission to view this user");
                    else
                        setError(err.response.data);

                });
        }
    }, [isValid]);

    useEffect(() => {
        setIsValid(formErrors.firstName === "" &&
            formErrors.lastName === "" &&
            formErrors.email === "");
    }, [formErrors])



    const handleSubmit = (event) => {
        event.preventDefault();

        setFormErrors({
            firstName: form.firstName == undefined || form.firstName == "" ? "First name is required" : "",
            lastName: form.lastName == undefined || form.lastName == "" ? "Last name is required" : "",
            email: form.email == undefined || form.email == "" ? "Email is required" : "",
        });

        
    }


    



    return (
        <div className="page">
            {submitting && (
                <SubmittingDialog />
            )}


            {error && (
                <div className="row">
                    <div className="col-8">
                        <h3>Failed To Update User</h3>
                        <p>{error}</p>
                    </div>
                </div>)}
            {loading && (<Spinner />)}
            {!error && !loading && form && (
                <>

                    <div className="row">
                        <div className="col-12">
                            <h1>
                              Edit User / Agent
                            </h1>
                        </div>
                    </div>

                    <Form onSubmit={handleSubmit} noValidate >

            
                    <div className="row">
                        {/* User Details */}
                        <div className="col-md-8">
                            <h3>Personal Details</h3>

                   
                            <div className="row">
                                <div className="col-md-6">
                                    { /* First Name */}
                                    <div className="form-group">
                                        <label>First Name</label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g John"
                                            isInvalid={formErrors && formErrors.firstName}
                                            onChange={(e) => setField("firstName", e.target.value)}
                                            value={form.firstName ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.firstName}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    { /* Last Name */}
                                    <div className="form-group">
                                        <label>Last Name</label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g Smith"
                                            isInvalid={formErrors && formErrors.lastName}
                                            onChange={(e) => setField("lastName", e.target.value)}
                                            value={form.lastName ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.lastName}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>

                            
                            <div className="row">

                                { /* Agent Number */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Agent Number</label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder="e.g 01"
                                            isInvalid={formErrors && formErrors.agentNumber}
                                            onChange={(e) => setField("agentNumber", e.target.value)}
                                            value={form.agentNumber ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.agentNumber}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>

                                { /* Role */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Role</label>
                                        <div className="select">
                                            <Form.Select 
                                                onChange={(e) => setField("role", e.target.value)}
                                                value={form.role ?? ""}
                                            >
                                                <option>User</option>
                                                <option>Agent</option>
                                                <option>Admin</option>
                                                <option>Director</option>
                                            </Form.Select>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <h3 style={{marginTop: 20}}>Login Details</h3>

                            { /* Email */}
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Email</label>
                                        <Form.Control
                                            required
                                            type="email"
                                            placeholder="e.g john@smith.com"
                                            isInvalid={formErrors && formErrors.email}
                                            onChange={(e) => setField("email", e.target.value)}
                                            value={form.email ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.email}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>

                            {!resetPassword && (
                                <div className="row">
                                    <div className="col-md-12">
                                            <a href="#" onClick={() => { setResetPassword(true) }} style={{cursor: "pointer"}}>Click to change password</a>
                                    </div>
                                </div>
                            )}

                            { resetPassword && (
                            <div className="row">
                                <div className="col-md-6">
                                    { /* Password */}
                                    <div className="form-group">
                                        <label>Password</label>
                                        <Form.Control
                                            required
                                            type="password"
                                            isInvalid={formErrors && formErrors.password}
                                            onChange={(e) => setField("password", e.target.value)}
                                            value={form.password ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.password}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    { /* Confirm Password */}
                                    <div className="form-group">
                                        <label>Confirm Password</label>
                                        <Form.Control
                                            required
                                            type="password"
                                            isInvalid={formErrors && formErrors.confirmPassword}
                                            onChange={(e) => setField("confirmPassword", e.target.value)}
                                            value={form.confirmPassword ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.confirmPassword}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                            )}

                            { /* Allow Login? */}
                            <div className="row">
                                <div className="col-md-12">
                                    <Form.Check
                                        type="checkbox"
                                        isInvalid={formErrors && formErrors.allowLogin}
                                        onChange={(e) => setField("allowLogin", e.target.checked)}
                                        checked={form.allowLogin ? true : false}
                                        label="Allow User To Login" />
                                </div>
                            </div>

                            <h3 style={{ marginTop: 20 }}>Contact Details</h3>

                            { /* Address */}
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Address</label>
                                        <Form.Control as="textarea" rows="5"
                                            placeholder="e.g Suite 12B"
                                            isInvalid={formErrors && formErrors.address}
                                            onChange={(e) => setField("address", e.target.value)}
                                            value={form.address ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.address}
                                        </Form.Control.Feedback>
                                        </div>
                                </div>
                            </div>

                            { /* Postcode */}
                            <div className="row">
                                <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Postcode</label>
                                            <Form.Control
                                                type="text"
                                                placeholder="e.g CA1 1AA"
                                                isInvalid={formErrors && formErrors.postcode}
                                                onChange={(e) => setField("postcode", e.target.value)}
                                                value={form.postcode ?? ""}
                                            />
                                            <Form.Control.Feedback className="text-danger" type="invalid">
                                                {formErrors.postcode}
                                            </Form.Control.Feedback>
                                        </div>
                                </div>
                            </div>

                            { /* Telephone */}
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Telephone</label>
                                        <Form.Control
                                            type="tel"
                                            placeholder="e.g 01228 123456"
                                            isInvalid={formErrors && formErrors.telephone}
                                            onChange={(e) => setField("telephone", e.target.value)}
                                            value={form.telephone ?? ""}
                                        />
                                        <Form.Control.Feedback className="text-danger" type="invalid">
                                            {formErrors.telephone}
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>

                        
                    
                        </div>

                        <div className="col-md-4">
                            <h3>Profile Image</h3>
                            <AvatarEditor onChange={setField} profileImage={form.profileImage} />
                        </div>
                    </div>
            


                    <hr />

                    {formErrors.general && (
                        <div className="row">
                            <div className="col-md-12">
                                <div className="alert alert-danger">
                                        {formErrors.general}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        <div className="col-md-12">
                            <button className="btn btn-primary">Update User</button>
                            <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Users/`) }}>Cancel</button>
                        </div>
                    </div>
                            </Form>
                </>
            )}
        </div>
  )
}
